import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type ButtonGroupVariantType, buttonGroupVariantList } from '../../typings/buttonGroupVariantType';
import { defaults } from '../defaults';

export const withButtonGroupVariantProps = {
  /**
   * Wariant grupy przycisków
   */
  variant: {
    type: String as PropType<ButtonGroupVariantType>,
    default: defaults.buttonGroup.variant
  }
};

/**
 * Zwraca klasę wariantu grupy przycisków
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withButtonGroupVariantProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useButtonGroupVariantProps = (
  prefix: string,
  props: ExtractPropTypes<typeof withButtonGroupVariantProps>
) => {
  return computed(() => ({
    [`${prefix}--${props.variant}`]: props.variant !== undefined
  }));
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesButtonGroupVariantArgs = {
  args: {
    variant: defaults.buttonGroup.variant
  },

  argTypes: {
    variant: {
      options: buttonGroupVariantList,
      control: { type: 'select' }
    }
  }
};
